import styled from "styled-components";

export const Wrapper = styled.div``;

export const InputWrapper = styled.div`
    position: relative;
`;

export const PlaceInput = styled.input`
    width: 100%;
    padding: 8px 12px;
    color: #3e3e3e;
    border: 1px solid #E8E8E8;
    outline: 0;
    border-radius: 3px;

    &:focus {
        border: 1px solid #50AFF4;
        box-shadow: 0px 0px 2px #50AFF4;
    }
`

export const Icon = styled.img`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    height: 14px;
    width: 14px;
    z-index: 1;
`;

export const Label = styled.span`
    color: #212121;
    font-weight: 500;
    line-height: 18px;
`

export const HelpText = styled.span`
    font-size: 10px;
    color: #878787;
    line-height: 15px;
`;

export const HelpLink = styled.a`
    color: #50AFF4;

    &:hover {
        opacity: 0.6;
    }
`;